
import {
  dispatchGetActivePackage,
  dispatchGetCompanyStats,
  dispatchGetPackages,
  dispatchGetPhysicalNodesList,
  dispatchGetVirtualNodesList,
  dispatchGetVirtualNodesActive,
  dispatchMakeProfixoneLink,
  dispAuthFetch,
  dispatchGetXcoinPackages,
} from "@/store/mlm/actions";
import {
  readActivePackage,
  readCompanyStats,
  readXcoinPackages,
  readVirtualNodesList
} from "@/store/mlm/getters";
import { Component, Vue } from "vue-property-decorator";
import {USER_ROLES} from '@/constants';
// import ValidatorModal from "@/components/Main/ValidatorModal.vue";
import { IDexSummerPromo, IPackage, IAcquiredNode, IVirtualNode, IPhysicalNode } from "@/interfaces/mlm";
import { readUserProfile } from "@/store/main/getters";

// Rigs
import ProductDescription from "@/components/Main/Rings/ProductDescription.vue";
// import StatusBar from "@/components/Main/StatusBar.vue";
import YesIcon from "@/components/Icons/YesIcon.vue";
import NoIcon from "@/components/Icons/NoIcon.vue";
import ActivatePromocode from "@/components/Main/ActivatePromocode.vue";
import ProductOrders from "@/components/Main/Rings/ProductOrders.vue";
// import BonusList from "@/components/Main/Bonus/BonusList.vue"; // 22.04.2026
// import BirthdayPromo from "@/components/Main/Promo/BirthdayPromo.vue";
// import SeptemberPromo from "@/components/Main/SeptemberPromoVirtualNodes.vue";
// import NovemberVNDiscount from "@/components/Main/Promo/NovemberVNDiscount.vue";
// import NovemberVNDiscountSmall from "@/components/Main/Promo/NovemberVNDiscountSmall.vue";
// import NovemberBlackFridayVirtualNodes from "@/components/Main/Promo/NovemberBlackFridayVirtualNodes.vue";
// import BirthdayPromoModal from "@/components/Main/Promo/BirthdayPromoModal.vue";
// import GiveAGiftModal from "@/components/Main/Transactions/GiveAGiftModal.vue"; 
import DepositModal from "@/components/Main/Transactions/DepositModal.vue";
import ProductPurchaseModal from "@/components/Main/ProductPurchaseModal.vue";
import PackagePaymentModal from "@/components/Main/PackagePaymentModal.vue";
import PackagePaymentNewModal from "@/components/Main/PackagePaymentNewModal.vue";
import MyPromocodeModal from "@/components/Main/MyPromocodeModal.vue";
import ProvideProfileDetailsModal from "@/components/Main/ProvideProfileDetailsModal.vue";
import MaintenanceModal from "@/components/Main/MaintenanceModal.vue";
import WinterPromoInfoModal from "@/components/Main/WinterPromoInfoModal.vue";
import DexPromoDetailModal from "@/components/Main/DexPromoDetailModal.vue";
import EthicsCodexModal from "@/components/Main/EthicsCodexModal.vue";
import PackagePaymentXCoinsModal from "@/components/Main/PackagePaymentXCoinsModal.vue";
import WelcomeResidentModal from '@/components/Main/WelcomeResidentModal.vue';
import UserXcoinOrders from "@/components/Main/Tokens/UserXcoinOrders.vue";
// import ReactivateBanner from "@/components/Main/Promo/ReactivateBanner.vue";
import PhysicalNodes from "@/components/Main/Nodes/PhysicalNodes.vue";
import VirtualNodes from '@/components/Main/Nodes/VirtualNodes.vue';
import VirtualNodesActive from '@/components/Main/Nodes/VirtualNodesActive.vue';
import PhysicalNodesActive from '@/components/Main/Nodes/PhysicalNodesActive.vue';
@Component({
  components: {
    YesIcon,
    NoIcon,
    // StatusBar,
    // BirthdayPromo,
    // NovemberBlackFridayVirtualNodes,
    // SeptemberPromo,
    // NovemberVNDiscount,
    // NovemberVNDiscountSmall,
    // BonusList,
    // ReactivateBanner,
    ProductOrders,
    UserXcoinOrders,
    ProductDescription,
    PhysicalNodes,
    PhysicalNodesActive,
    VirtualNodes,
    VirtualNodesActive,
// -- modals -- //
    PackagePaymentXCoinsModal,
    PackagePaymentNewModal,
    DepositModal,
    // GiveAGiftModal,
    PackagePaymentModal,
    WinterPromoInfoModal,
    // BirthdayPromoModal,
    // ValidatorModal,
    MaintenanceModal,
    MyPromocodeModal,
    ActivatePromocode,
    DexPromoDetailModal,
    EthicsCodexModal,
    ProvideProfileDetailsModal,
    ProductPurchaseModal,
    WelcomeResidentModal
  },
})

export default class Dashboard extends Vue {
  public isProduction: boolean = process.env.VUE_APP_ENV === "production";
  public showPromocodeModal: boolean = false;
  public showProfileDetailsModal: boolean = false;
  public showMaintenanceModal: boolean = false;
  public showActivatePromocodeModal: boolean = false;
 
  public showPromoDetailModal: boolean = false;
  public showECodexModal: boolean = false;
  // public showValidatorModal: boolean = false;
  public showWinterPromoModal: boolean = false;
  public requestedShowPromo: boolean = false;
  public packageDepositList = []
 
  public selectedNewPackage = null
  // public selectedVirtualPackage = null
  public timeInterval: any = null;
  public promoStatus: IDexSummerPromo | null = null;
  public promoStats: any = null
  // public giftModalShow = false;
  public depositModalShow = false;
  public isOpenMyPromocodeNewModal = false;
  // public tariffUpgradeModal = false;
  // public currentTariff: IAcquiredNode | null = null;
  // public acquiredNodes: IAcquiredNode[] = []


  public showWelcomeResidentModal = false; // !localStorage.getItem('welcomeResidentModalShown');
  public showBirthdayPromoModal = false;

   public selectedXcoinPackage = null;

  readonly USER_ROLES = USER_ROLES;

 

 

  public products: {
    name: string;
    quantity: number;
    decsription: string;
    descr: {
      location: string;
      title: string;
      date: string;
      text: string | null;
      link: string | null;
      logo: string;
      bg: string;
    };
    available: boolean;
    price: number;
  }[] = [];
  public showProductPurchaseModal: boolean = false;
  public selectedProduct: any = null;

  public activePage: number = 1;
  public selectedTypeNode: number = 1
  // public virtual_nodes:IVirtualNode[] = []
  // public showVirtualPackagePaymentModal = false

  // X Coins
   public showXCoinsPaymentModal = false

  // --- rings --- //
  public selectedRingProductType: number = 1;

  // --- physical nodes --- //

  // --- methods --- //

  // public async loadPackageDepositList() {
  //   const invoiceResp = await dispAuthFetch(this.$store, {
  //     input: "/api/v1/token_service_integration/token_packages/",
  //     init: {
  //       method: "GET",
  //     },
  //   });

  //   if (invoiceResp.status === 200) {
  //     const invoiceResponse = await invoiceResp.json();
  //     return invoiceResponse;
  //   } else {
  //     this.$toast.error("Failed to create invoice, please try again later", {
  //       message: "Failed to create invoice, please try again later",
  //       duration: 3000,
  //       position: "bottom",
  //     });
  //     return null;
  //   }
  // }

  public async loadVirtualPackageDepositList() {
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/virtual_nodes/",
      init: {
        method: "GET",
      },
    });

    if (invoiceResp.status === 200) {
      const invoiceResponse = await invoiceResp.json();
      return invoiceResponse;
    } else {
      this.$toast.error("Failed to create invoice, please try again later", {
        message: "Failed to create invoice, please try again later",
        duration: 3000,
        position: "bottom",
      });
      return null;
    }
  }


  public openProductPurchaseModal(product: any) {
    this.selectedProduct = product;
    this.showProductPurchaseModal = true;
  }

  public closeProductPurchaseModal() {
    this.showProductPurchaseModal = false;
    this.selectedProduct = null;
  }

  // public handleOpenGiftModal() {
  //   this.giftModalShow = true;
  // }

  // public handleCloseGiftModal(updated: boolean = false, action) {
  //   this.giftModalShow = false;

  //   if(action == 'needCash') {
  //     this.handleOpenDepositModal()
  //   }
  // }

  public handleCloseDepositModal() {
    this.depositModalShow = false;
  }

  public handleOpenDepositModal() {
    this.depositModalShow = true;
  }

  // --- Tariff Upgrade --- //
  // public handleCloseTariffUpgradeModal() {
  //   this.tariffUpgradeModal = false;
  // }

  // public handleOpenTariffUpgradeModal(current_tariff:IAcquiredNode) {
  //   this.currentTariff = current_tariff
  //   this.tariffUpgradeModal = true;
  // }

  public async getPromoStatus() {
    try {
      const response = await dispAuthFetch(this.$store, {
        input: "/api/v1/mlm/global_market_promo/",
        init: {
          method: "POST",
        },
      });

      if (response.status === 200) {
        const data = await response.json();
        this.promoStats = data
      }
    } catch (error) {}
  }

  public openWinterPromoModal() {
    this.showWinterPromoModal = true;
  }

  public closeWinterPromoModal() {
    this.showWinterPromoModal = false;
  }

  // public validatorInfo: {
  //   available_count: number;
  //   available: boolean;
  //   own: number;
  //   left: number;
  // } = {
  //   available_count: 0,
  //   available: false,
  //   own: 0,
  //   left: 0,
  // };

  /** November */
  public discount = 15;
    public showTooltip = false;

    public handleMouseEnter(): void {
        this.showTooltip = true;
    }

    public handleMouseLeave(): void {
        this.showTooltip = false;
    }
    // ------------

  public winterPromo: {
    current_status: string;
    next_status: string;
    personal_sales: number;
    personal_sales_left: number;
    personal_sales_req: number;
    team_sales: number;
    team_sales_left: number;
    team_sales_req: number;
    greater_branch_sales: number;
  } = {
    current_status: "NONE",
    next_status: "SILVER",
    personal_sales: 0,
    personal_sales_left: 3,
    personal_sales_req: 0,
    team_sales: 0,
    team_sales_left: 10,
    team_sales_req: 0,
    greater_branch_sales: 0,
  };

  public beforeRouteLeave(to, from, next) {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
    next();
  }

  public async mounted() {
    const productsResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/product/check_available/",
      init: {
        method: "POST",
        body: {},
      },
    });

    const winterPromoResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/dex_winter_promo/",
      init: {
        method: "POST",
        body: {},
      },
    });

    this.winterPromo = await winterPromoResp.json();

    this.products = await productsResp.json().then((products) =>
      products.map((p) => {
        try {
          p.descr = JSON.parse(p.decsription);
        } catch (error) {
          console.error(
            `Failed to parse description for product: ${p.name}`,
            error
          );
          p.descr = {}; // Set a default value
        }
        return p;
      })
    );

   
    await dispatchGetActivePackage(this.$store);

  
    
     await dispatchGetXcoinPackages(this.$store); // 13.04.2026
     // await dispatchGetXcoinActivePackages(this.$store);
    this.updatePromoInfo();
    
    if (
      this.activePackage &&
      this.userProfile &&
      (
          !this.userProfile.country ||
          !this.userProfile.first_name
        // !this.userProfile.last_name ||
        // !this.userProfile.tg_username
      )
    ) {
      this.showProfileDetailsModal = true;
    }
  // console.log('user_id ', this.userProfile?.id)

  if(this.userProfile?.role == 'OLD_USER') {
    // Проверяем, было ли модальное окно уже показано
    const welcomeModalShown = localStorage.getItem('welcomeResidentModalShown');
    if (!welcomeModalShown) {
      this.showWelcomeResidentModal = true;
    }
  }

    if (new Date() < new Date("2024-03-10 21:00:00")) {
      const informedMaintenance = localStorage.getItem("informedMaintenance");
      if (!informedMaintenance) {
        this.showMaintenanceModal = true;
      }
    }

    await this.getPromoStatus()

    // this.packageDepositList = await this.loadPackageDepositList()
    await dispatchGetPhysicalNodesList(this.$store);
    await dispatchGetVirtualNodesList(this.$store);
    await dispatchGetVirtualNodesActive(this.$store);

   // this.virtual_nodes = await this.loadVirtualPackageDepositList()
    // this.acquiredNodes = await this.loadAcquiredNodes()

  }

  // public async loadAcquiredNodes() {
  //   const invoiceResp = await dispAuthFetch(this.$store, {
  //     input: "/api/v1/mlm/virtual_node/active/",
  //     init: {
  //       method: "GET"
  //     },
  //   });

  //   if (invoiceResp && invoiceResp.status === 200) {
  //     return await invoiceResp.json()
  //   }
  //   return []
  // }

  // public async handleUpdateAcquiredNodes() {
  //   this.acquiredNodes = await this.loadAcquiredNodes()
  // }

  public async updatePromoInfo() {
    if (this.$route.path.includes("dashboard")) {
      await dispatchGetCompanyStats(this.$store);
      setTimeout(() => {
        this.updatePromoInfo();
      }, 60000);
    }
  }

  public convertToUTC(date) {
    // Преобразуем переданную дату в UTC и возвращаем её в миллисекундах
    return new Date(date).getTime();
  }

  

  //
  // public handleOpenValidatorModal() {
  //   this.showValidatorModal = true;
  // }
  //
  // public handleCloseValidatorModal() {
  //   this.showValidatorModal = false;
  // }

  

  // public handleOpenVirtualPackagePaymentModal(pack) {
  //   this.selectedVirtualPackage = pack;
  //   this.showVirtualPackagePaymentModal = true;
  // }

  public handleOpenPackageNewPaymentModal(pack) {
    this.selectedNewPackage = pack;
    this.isOpenMyPromocodeNewModal = true;
  }
  // 13.04.2026
  public handleOpenPackageXCoinsPaymentModal(pack) {
    // this.selectedNewPackage = pack;
    // this.isOpenMyPromocodeNewModal = true;
    this.selectedXcoinPackage = pack;
    this.showXCoinsPaymentModal = true;
  }

  

  public async handleOpenPromocodeModal() {
    const productsResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/package/active/",
      init: {
        method: "PATCH",
        body: {
          other_userpackage_info: {
            userpackage_info_checked: true
          }
        },
      },
    });

    await dispatchGetActivePackage(this.$store);

    //fixme принять этический кодекс при показе промокодов
    // if (this.userProfile?.code_of_etics_status !== "chk") {
    //   this.showECodexModal = true;
    //   this.requestedShowPromo = true;
    //   return;
    // }
    this.showPromocodeModal = true;
  }

  public handleClosePromocodeModal(pack) {
    this.showPromocodeModal = false;
    // if(pack != null) {
    //   this.selectedPackage = pack;
    //   this.showPackagePaymentModal = true;
    // }
  }

  public handleCloseECodexModal(result) {
    this.showECodexModal = false;
    if (result && this.requestedShowPromo) {
      this.showPromocodeModal = true;
    }
  }

  public handleCloseProfileDetailsModal() {
    this.showProfileDetailsModal = false;
  }

  public handleOpenActivatePromocodeModal() {
    this.showActivatePromocodeModal = true;
  }

  public handleCloseMaintenanceeModal() {
    this.showMaintenanceModal = false;
    localStorage.setItem("informedMaintenance", "true");
  }

  public handleCloseWelcomeResidentModal() {
    this.showWelcomeResidentModal = false;
    localStorage.setItem("welcomeResidentModalShown", "true");
  }

  public handleCloseBirthdayPromoModal() {
    this.showBirthdayPromoModal = false;
  }

  public handleOpenBirthdayPromoModal() {
    this.showBirthdayPromoModal = true;
  }

  public async handleOpenProfix() {
    const result = await dispatchMakeProfixoneLink(this.$store);
    if (result && result.url) {
      window.location.href = result.url;
    }
  }

  public async handleCloseActivatePromocodeModal(updated: boolean = false) {
    this.showActivatePromocodeModal = false;
    if (updated) {
      await dispatchGetPackages(this.$store);
      await dispatchGetActivePackage(this.$store);
      // if (
      //   this.activePackage &&
      //   this.activePackage.lost_profit > 0 &&
      //   this.activePackage?.expire_dt
      // ) {
      //   this.initializeClock(this.activePackage?.expire_dt);
      // }
    }
  }

 

  

  get activePackage() {
    return readActivePackage(this.$store);
  }

  

  get companyStats() {
    return readCompanyStats(this.$store);
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  get promoProgress() {
    if (this.promoStatus && this.promoStatus.progress) {
      if (this.promoStatus.progress <= 50) {
        let v = (this.promoStatus.progress / 50) * 100;
        return 33 * (v / 100);
      } else if (this.promoStatus.progress <= 75) {
        let v = (this.promoStatus.progress / 75) * 100;
        return 67 * (v / 100);
      } else {
        return this.promoStatus.progress;
      }
    }
    return 0;
  }

  get virtualNodesList() {
    return readVirtualNodesList(this.$store);
  }


  get maxVirtualNodeDiscount() {
    if (!this.virtualNodesList || this.virtualNodesList.length === 0) {
      return null;
    }

    const nodesWithDiscount = this.virtualNodesList.filter(
      (node) => node.discount_available && node.discount_percent
    );

    if (nodesWithDiscount.length === 0) {
      return null;
    }

    return Math.max(
      ...nodesWithDiscount.map((node) => Number(node.discount_percent))
    );
  }
  // 13.06.2026
  get xcoinPackageList() {
    // const activeXcoinPackages = readXcoinPackages(this.$store)
    // .filter(el => el.is_active)
    return readXcoinPackages(this.$store)
  }
}
